import { Component, Input } from '@angular/core';
import { TextCleanPipe } from '../pipes/text-clean-pipe';
import { formatAnalysisText } from '../services/format-analysis-text';
import { splitInHalf } from '../array-utils';

export interface V3ZeroContentGridItem {
  title: string;
  text: string;
}

// Zero desktop's version of V3FinnetContentGrid — same 2-column/divider/850px-collapse
// mechanics (see v3-finnet-content-grid/CLAUDE.md), Zero-styled: no notch on item titles
// (unlike Zero mobile's notch+label row — this is desktop-only), --v2-table-divider instead
// of Finnet's card-border token, --color-white body text (already theme-correct).
@Component({
  selector: 'app-v3-zero-content-grid',
  templateUrl: './v3-zero-content-grid.html',
  styleUrl: './v3-zero-content-grid.scss',
  standalone: true,
  imports: [TextCleanPipe],
})
export class V3ZeroContentGrid {
  @Input() items: V3ZeroContentGridItem[] = [];

  // Plain getters, not computed() — items is a plain @Input(), same pitfall documented on
  // V3FinnetContentGrid's leftColumn/rightColumn.
  get leftColumn(): V3ZeroContentGridItem[] {
    return splitInHalf(this.items)[0];
  }

  get rightColumn(): V3ZeroContentGridItem[] {
    return splitInHalf(this.items)[1];
  }

  readonly formatText = formatAnalysisText;
}
